import { render, staticRenderFns } from "./PositionScreeningQuestions.vue?vue&type=template&id=45f9cac0&scoped=true"
import script from "./PositionScreeningQuestions.vue?vue&type=script&lang=js"
export * from "./PositionScreeningQuestions.vue?vue&type=script&lang=js"
import style0 from "./PositionScreeningQuestions.vue?vue&type=style&index=0&id=45f9cac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f9cac0",
  null
  
)

export default component.exports